<template>
  <nav role="menu" class="main-nav-menu">
    <div
      v-for="(group, index) in mainMenu"
      :key="index"
      class="main-nav-menu__group"
      data-test-id="main-nav-menu-group"
    >
      <EList role="menuitem">
        <EListItem v-for="item in group" :key="item.label">
          <a
            :href="item.url"
            data-track-id="menu"
            class="main-nav-menu__link"
            data-test-id="main-nav-menu-link"
            rel="noopener"
          >
            {{ $t(`${translationStringPrefix}${item.key}${translationStringSufix}`) }}
          </a>
        </EListItem>
      </EList>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex';
import { getMainMenu } from '~~/common/js/universal/menus';

import EList from '~~/common/vue/components/list';
import EListItem from '~~/common/vue/components/list-item';

export default {
  name: 'EMainNavMenu',
  components: {
    EList,
    EListItem,
  },
  props: {
    translationStringPrefix: {
      type: String,
      default: 'common.header.menu.',
    },
    translationStringSufix: {
      type: String,
      default: '',
    },
    settingsUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    mainMenu() {
      return getMainMenu(this.locale, this.settingsUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-nav-menu {
  font-size: $font-m;
  min-width: 240px;

  .list-item {
    padding: 0;
  }
}

.main-nav-menu__group {
  @include divider('bottom');

  &:last-child {
    border-bottom: 0;
  }
}

.main-nav-menu__link {
  display: flex;
  padding: $space-s;
  align-items: center;
  flex-wrap: wrap;
}
</style>
